<template> 
  <publish-form :is-edit='true' :queryId='queryId'></publish-form>
</template>
<script>
  import PublishForm from './publishForm'
  export default {
    name: 'publishUpdate',
    components: { PublishForm },
    data() {
      return {
        queryId: ''
      }
    },
    created() {
      this.queryId = this.$route.query.id
    },    
  }
</script>
<style>
</style>


